import { range } from 'lodash-es'
import moment from 'moment'

export default {
  state: {},
  mutations: {},
  actions: {},
  getters: {
    daysOfMonth(state, getters, rootState) {
      const { month, year } = rootState.settings
      const date = moment().year(year).month(month)
      const isMonday = (day) => {
        const formatDay = date.date(day).format('ddd')
        return (day === 1 && formatDay !== 'Sat' && formatDay !== 'Sun') || formatDay === 'Mon'
      }
      const daysCount = date.daysInMonth()
      return range(1, daysCount + 1).map((day) => ({
        weekday: date.date(day).format('ddd'),
        label: day,
        weeks: isMonday(day) && `${Math.round(day / 7) + 1}W`,
      }))
    },
    monthsOfQuarter(state, getters, rootState) {
      const rtbWeeks = rootState.budget.rtb.weeks
      if (!rtbWeeks) {
        return getters.daysOfMonth
      }
      const weeks = []
      let savedMonth
      for (const [i, week] of rtbWeeks.entries()) {
        const month = moment(week.start).month()
        const isNewMonth = month !== savedMonth || i === 0
        weeks.push({
          label: week.label,
          weeks: isNewMonth && `${month + 1}M`,
        })
        savedMonth = month
      }
      return weeks
    },
    monthsOfYear(state, getters, rootState) {
      const { year } = rootState.settings
      const months = moment.monthsShort()
      const result = []
      for (const [i, month] of months.entries()) {
        const quarter =
          (i === 0 || i === 3 || i === 6 || i === 9) && moment().month(month).quarter()
        result.push({
          label: `${month}\`${year.toString().substr(2)}`,
          weeks: quarter && `${quarter}Q`,
        })
      }
      return result
    },
    weeks(state, getters, rootState) {
      const { viewType } = rootState.settings
      return getters[viewType]
    },
  },
}
